import React, { useEffect } from 'react';
import { FileError } from 'react-dropzone';

import useUploadDropzone from '@/components/controls/DropScan/hooks/useUploadDropzone';

interface Props {
  onUpload?: () => void;
  onFileUploadError?: (error?: FileError) => void;
  onLoadingChange?: (isLoading: boolean) => void;
  storeKey?: string;
  multiple?: boolean;
  maxFiles?: number;
  disableFilesUpload?: boolean;
  ocrRequired?: boolean;
  children: (params: { open: () => void; isLoading: boolean }) => React.ReactNode;
}

/**
 * Renders no UI of its own - gives access to the same upload/dropzone logic
 * as `UploadButton` via a render-prop, so any custom element (icon, card, etc.)
 * can become an upload trigger.
 */
const UploadTrigger: React.FC<Props> = ({
  onUpload,
  onFileUploadError,
  onLoadingChange,
  storeKey,
  multiple,
  maxFiles,
  disableFilesUpload,
  ocrRequired,
  children,
}) => {
  const { open, getInputProps, isLoading } = useUploadDropzone({
    onUpload,
    onFileUploadError,
    storeKey,
    multiple,
    maxFiles,
    disableFilesUpload,
    ocrRequired,
  });

  useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  return (
    <>
      {children({ open, isLoading })}
      <input {...getInputProps()} />
    </>
  );
};

export default UploadTrigger;
